import {
  AppBar,
  Box,
  Button,
  Grid,
  Tab,
  Tabs,
  Toolbar,
  Typography,
  Switch,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../../../Components/BreadCrumb';
import { useHistory, useParams } from 'react-router-dom';
import routes from '../../../../../Utils/routes.json';
import { useEffect, useState } from 'react';
import KenCard from '../../../../../global_components/KenCard';
import GradingComponent from './GradingComponent';
import GradeScale from './GradeScale';
import { GradeSetting } from './GradeSetting';
import ApprovalMechanism from './ApprovalMechanism';
import { getEvaluationMasterData } from '../../../../../Utils/apiServices';
import GradingPenalty from './GradingPenalty';
import GradingScaleAccordian from './GradingScale/GradingScaleAccordian';
import GradingSettings from './GradingSettings';
import CourseGrading from './GradingSettings/CourseGrading';
import InstituteGradingScreen from './GradingSettings/InstituteGradingScreen';
import CustomLetterGrade from './GradingScale/CustomLetterGrade/CustomLetterGrade';

const arrayBreadCrumb = [
  { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'GRADING',
    url: routes.grading,
  },
  {
    head: 'GRADING SETTING',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    height: '28px',
    width: '78px',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    color: '#FFFFFF',
    background: 'orange',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  normal: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: 'green',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#F2994A',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  switchTitleText: {
    fontSize: '14px',
    lineHeight: '38px',
    fontWeight: 'bolder',
    textTransform: 'uppercase',
  },
}));

const selectOptionsCourse = [
  {
    label: 'Room 1',
    value: '1',
  },
  {
    label: 'Room 2',
    value: '2',
  },
  {
    label: 'Room 3',
    value: '3',
  },
];
const selectRoom = [
  {
    label: 'Room 1',
    value: '1',
  },
  {
    label: 'Room 2',
    value: '2',
  },
];

const selectOptionsSpace = [
  {
    label: '1',
    value: 1,
  },
  {
    label: '2',
    value: 2,
  },
];

function TabPanels(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const GradingSetting = () => {
  const history = useHistory();
  const classes = useStyles();
  const SEATING_COLUMNS = 6;
  const [layoutSize, setLayoutSize] = useState(true);
  let { id } = useParams();
  console.log('params id', id);
  // {
  //   label: 'Room 2',
  //   value: '2',
  // },
  //Get Data from API through params : id
  const currentSeatingPlanData = {
    id: 1,
    course: 'Course 1',
    subject: 'Subject 1',
    candicate: '100',
    date: new Date(), // Date from api
    start_time: '10:30 AM',
    duration: '2',
    exam_type: 'Offline',
  };

  // Tab Panel states
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [roomChoosen, setRoomChoosen] = useState([]);
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  // Automatic select
  const roomDropdown = roomChoosen.map((ele) => {
    return {
      label: `Room ${ele.room}`,
      value: ele.id,
    };
  });

  // const handleSelectChangeCourse = (e) => {
  //   setSelectValueCourse(e.target.value);
  // };

  // Seating Arrangment
  const [selectValueSpace, setSelectValueSpace] = useState(
    selectOptionsSpace[0].value
  );
  // const handleSelectChangeSpace = (e) => {
  //   setSelectValueSpace(e.target.value);
  // };

  // Eligible for seating arrangement
  const [eligible, setEligible] = useState(false);

  const [numStudents, setNumStudents] = useState(0);
  console.log('valueTab', value);
  // selectOptionsCourse.push()
  let seatWidth = '100%';
  /* Evaluation Master Data API*/
  const [evaluationMasterData, setEvaluationMasterData] = useState([]);

  useEffect(() => {
    let gradingId = 'a196D000000gcCSQAY';
    getEvaluationMasterData()
      .then((res) => {
        console.log('Evaluation Master Data API', res);
        setEvaluationMasterData(res);
      })
      .catch((err) => {
        console.log('Evaluation Master Data API', err);
      });
  }, []);

  const [state, setState] = useState({
    checkedA: false,
  });

  const handleChange12123 = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  console.log('objectobjectobjectobjectobjectobject', state.checkedA);
  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>

      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          {' '}
          <Grid container>
            <Grid xs={8}>
              {' '}
              <Typography variant="h6" className={classes.title}>
                Grading
              </Typography>{' '}
            </Grid>{' '}
            {/* <Grid xs={4}>
              {' '}
              <Grid container>
                <Typography className={classes.switchTitleText}>
                  {' '}
                  Institute Level{' '}
                </Typography>
                <Switch
                  checked={state.checkedA}
                  onChange={handleChange12123}
                  color="primary"
                  name="checkedA"
                  label="Secondary"
                  inputProps={{ 'aria-label': 'secondary checkbox' }}
                />{' '}
                <Typography className={classes.switchTitleText}>
                  {' '}
                  Course Level{' '}
                </Typography>
              </Grid>
            </Grid> */}
          </Grid>
        </Toolbar>
      </AppBar>
      {/* <AppBar
        position="static"
        elevation={0}
        className={classes.header}
        style={{ margin: '20px 0' }}
      >
        <Toolbar style={{ color: '#505F79', fontWeight: 'bold' }}>
          <Typography variant="p" style={{ marginRight: '25px' }}>
            {currentSeatingPlanData.course}
          </Typography>

          <Typography variant="p">Monday, 20th January, 2022</Typography>
        </Toolbar>
      </AppBar> */}

      <div className="cardlsitbox">
        <KenCard elevation={0}>
          <Box sx={{ width: layoutSize ? 'calc(100%' : '100%' }}>
            <Box
              sx={{ borderBottom: 1, borderColor: 'divider' }}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                {' '}
                <Tab
                  label="Custom Letter Grade"
                  {...a11yProps(0)}
                  style={{ fontSize: '12px' }}
                />
                <Tab
                  label="DEFAULT GRADING SETTING"
                  {...a11yProps(1)}
                  style={{ fontSize: '10px' }}
                />
                <Tab
                  label="Downgrading Rules"
                  {...a11yProps(2)}
                  style={{ fontSize: '12px' }}
                />{' '}
                {/* <Tab
                  label="Evaulation Master Component"
                  {...a11yProps(3)}
                  style={{ fontSize: '12px' }}
                /> */}
              </Tabs>
            </Box>
            <TabPanels value={value} index={0}>
              <CustomLetterGrade />
            </TabPanels>
            <TabPanels value={value} index={1}>
              <GradingSettings />
            </TabPanels>
            <TabPanels value={value} index={2}>
              <GradingPenalty />
            </TabPanels>{' '}
            {/* <TabPanels value={value} index={3}>
              <GradingComponent />
            </TabPanels>{' '} */}
          </Box>
        </KenCard>
      </div>
    </Box>
  );
};

export default GradingSetting;
